window.addEventListener("hoContentLoaded", () => {

	Vue.component('block-special-image-before-after-slider', {
		mixins: [mixinViewport],
		data: () => ({
			percent : 0,
			dragging : false,
			imageAfter: null,
			imageAfterFigure : null,
			isDrag : false
		}),

		methods: {
			dragStart(event)
			{
				this.dragging = true;
				document.addEventListener('mouseup', this.dragEnd, {passive: true});
				document.addEventListener('touchend', this.dragEnd, {passive: true});
				document.addEventListener('touchmove', this.drag, {passive: true});
				document.addEventListener('mousemove', this.drag, {passive: true});
			},

			drag(event)
			{
				let pageX = 0;

				const bounds = this.viewport(this.$refs.progress);


				if (event.changedTouches)
				{
					pageX = event.changedTouches[0].pageX;
				}
				else
					pageX = event.pageX;

				let perc = ((pageX - bounds.l) / bounds.w);

				if (perc < 0)
				{
					perc = 0;
				}
				else if (perc > 1)
				{
					perc = 1;
				}

				this.dragUpdate(perc);
				this.percent = perc;
			},

			dragEnd(event)
			{

				this.dragging = false;
				this.drag(event);
				document.removeEventListener('mousemove', this.drag, {passive: true});
				document.removeEventListener('mouseup', this.dragEnd, {passive: true});
				document.removeEventListener('touchend', this.dragEnd, {passive: true});
				document.removeEventListener('touchmove', this.drag, {passive: true});
			},

			dragUpdate(perc)
			{
				let t = this.percent - perc;
				let pPerc = perc + .03;

				if (t < 0)
					t *= -1;

				t *= 2;

				if (t > .1)
				{
					t *= 2;
				}

				if (t > .9)
				{
					t = .9;
				}

				if (t > 0)
				{
					gsap.killTweensOf(this.imageAfter);
					gsap.killTweensOf(this.imageAfterFigure);
					gsap.killTweensOf(this.$refs.pointer);

					gsap.to(this.imageAfter, t, {x: (perc * 100) + "%", ease: "power4.out"});
					gsap.to(this.imageAfterFigure, t, {x: (-perc * 100) + "%", ease: "power4.out"});
					gsap.to(this.$refs.pointer, t, {x: (perc * 100) + "vw", ease: "power4.out"});
				}
			},

			scroll()
			{
				const viewport = this.viewport(this.$el);

				let top = 0;
				let bottom = top + window.innerHeight;
				let t = top - viewport.h;
				let b = bottom + viewport.h;

				const inViewport = (t < viewport.t && b > (viewport.y + viewport.h));
				let p = (viewport.y+(viewport.h*.5)) / ((window.innerHeight-.7));

				if (inViewport)
				{
					let f = 1;

					if(p > 1)
					{
						p = 1;
					}

					if (p > 0 && p < 1)
					{
						if (this.percent !== p)
						{
							this.percent = 1 - p;
							this.scrollUpdate();
						}
					}

					if (!this.inViewport)
					{
						this.inViewport = true;
					}
				}
				else
				{
					if (this.inViewport)
					{
						this.inViewport = false;
					}
				}
			},

			scrollUpdate()
			{
			//	console.log("scrollUpdate:",this.percent);
				gsap.set(this.imageAfter,{x:(this.percent*100)+"%"});
				gsap.set(this.imageAfterFigure,{x:(-this.percent*100)+"%"});
			},
		},

		beforeDestroy()
		{
			this.animationFrameListenKill(this.scroll);
		},

		mounted()
		{
			this.imageAfter = this.$refs.imageAfter;
			this.imageAfterFigure = this.imageAfter.querySelector("figure");

			if(this.$refs.wrapper.dataset.interaction === "drag")
			{
				this.isDrag = true;
				this.percent = .5;
				gsap.set(this.$refs.pointer,{x:(this.percent*100)+"vw",ease:"power4.out"});
				gsap.set(this.imageAfter,{x:(this.percent*100)+"%"});
				gsap.set(this.imageAfterFigure,{x:(-this.percent*100)+"%"});
			}
			else
			{
				this.animationFrameListen(this.scroll);
			}
		}
	});
});
